// Polyfill require IE 9+
// This polyfill only convert ScrollToOptions and ScrollIntoViewOptions to supported arguments
// This doesn't polyfill smooth scrolling nor scrollIntoView alignment
// https://developer.mozilla.org/en-US/docs/Web/API/Window/ScrollTo
// https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior
// See also https://github.com/Modernizr/Modernizr/issues/1568
// See also https://github.com/iamdustan/smoothscroll/blob/master/src/smoothscroll.js
// https://caniuse.com/#feat=element-scroll-methods
// https://caniuse.com/#feat=scrollintoview
// https://caniuse.com/#feat=css-scroll-behavior
/*
All:
window.scroll: ƒ scroll()
window.scrollBy: ƒ scrollBy()
window.scrollTo: ƒ scrollTo()

chrome & firefox
  Window.prototype.scroll: undefined
  Window.prototype.scrollBy: undefined
  Window.prototype.scrollTo: undefined
IE & Safari
  Window.prototype.scroll: ƒ scroll()
  Window.prototype.scrollBy: ƒ scrollBy()
  Window.prototype.scrollTo: ƒ scrollTo()

chrome > 60
  Element.prototype.scroll: ƒ scroll()
  Element.prototype.scrollBy: ƒ scrollBy()
  Element.prototype.scrollTo: ƒ scrollTo()
  document.body.scroll: ƒ scroll()
  document.body.scrollBy: ƒ scrollBy()
  document.body.scrollTo: ƒ scrollTo()
chrome <= 60
  Element.prototype.scroll: undefined
  Element.prototype.scrollBy: undefined
  Element.prototype.scrollTo: undefined
  document.body.scroll: undefined
  document.body.scrollBy: undefined
  document.body.scrollTo: undefined

 */

var supportDescriptors = require('core-js/internals/descriptors');
var defineProperties = require('core-js/internals/object-define-properties');
var elementProto = Element.prototype;
var winProto = Window.prototype;
var methods = ["scroll", "scrollBy", "scrollTo"];

/**
 * Get scroll position from provided args
 * @param {{left: number, top: number}[]|number[]} args
 * @param {number} defaultTop
 * @param {number} defaultLeft
 * @return {number[]}
 */
function getPositionsFromArguments(args, defaultLeft, defaultTop){
  defaultLeft = Number(defaultLeft);
  defaultTop = Number(defaultTop);
  var top = NaN;
  var left = NaN;

  var options = Object(args[0]);
  // element.scroll(options)
  if(options.top !== undefined || options.left !== undefined){
    if(options.top !== undefined){
      top = Number(options.top);
    }
    if(options.left !== undefined){
      left = Number(options.left);
    }
  }
  // element.scroll(x-coord, y-coord);
  else{
    top = Number(args[0]);
    left = Number(args[1]);
  }

  return [isNaN(left) ? defaultLeft : left, isNaN(top) ? defaultTop : top];
}

// Add missing methods
// element.scroll()
// element.scrollTo()
// element.scrollBy()
if (supportDescriptors && !elementProto.hasOwnProperty('scrollTo')) {
  var scrollPropertyDescription = {
    configurable: true,
    value: function () {
      var positions = getPositionsFromArguments(arguments, this.scrollLeft, this.scrollTop);
      this.scrollLeft = positions[0];
      this.scrollTop = positions[1];
    }
  };

  defineProperties(elementProto, {
    "scroll": scrollPropertyDescription,
    "scrollTo": scrollPropertyDescription,
    "scrollBy": {
      configurable: true,
      value: function () {
        var positions = getPositionsFromArguments(arguments, 0, 0);
        this.scrollLeft += positions[0];
        this.scrollTop += positions[1];
      }
    },
  });
}

/**
 * Patch method of target
 * @param {Object} target
 * @param {string} methodName
 */
function patchMethod(target, methodName, getSupportedArguments){
  var originalMethod = target[methodName];

  target[methodName] = function(){
    originalMethod.apply(this, getSupportedArguments(arguments));
  };
}

// On IE, body.scroll is not a function but an property/attribute setter/getter to hide scrollbars http://help.dottoro.com/lhjiqodn.php
try{
  delete HTMLBodyElement.prototype.scroll
}catch(error){}

// Patch window prototpe or window Shouldn't support ScrollToOptions attribute
// FIXME: patch iframe.contentWindow could be required too
if (!('scrollBehavior' in document.documentElement.style)) {
  var target = winProto.hasOwnProperty("scrollTo") ? winProto : window;// some browsers (Chrome & Firefox) don't have

  for (var i = 0; i < methods.length; i++) {
    patchMethod(target, methods[i], getPositionsFromArguments);
  }

  patchMethod(elementProto, "scrollIntoView", function(args){
    // Already supported signature
    if(
      // element.scrollIntoView();
      args.length === 0

      // element.scrollIntoView(alignToTop); // Boolean parameter
      || typeof args[0] === "boolean"
    ){
      return args;
    }

    // element.scrollIntoView(scrollIntoViewOptions); // Object parameter
    var options = Object(args[0]);
    var block = options.block || "start";
    var inline = options.inline || "nearest";
    if(block === "start"){
      return [true];
    }
    if(block === "end"){
      return [false];
    }

    return [];
  });
}
